module.exports = __webpack_public_path__ + "static/home-agent-7fb9532c34ad040d9584f213670fe958.png";